import { initFlowbite } from 'flowbite';
import $ from 'jquery';
import {
  getEndCursor,
  getHasNextPage,
  setEndCursor,
  setHasNextPage,
} from './state';

$(() => {
  const isHomePage = $('body').hasClass('home');
  const currentUrl = window.location.href;
  const infiniteLoader = $('#infinite-scroll-loader');
  const scrollTrigger = $('#infinite-scroll-trigger');
  let loading = false;
  let termID = null;

  const initializeScrollObserver = () => {
    if (scrollTrigger.get(0)) {
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && getHasNextPage()) {
          loadMoreProducts();
        }
      });
      observer.observe(scrollTrigger.get(0));
    }
  };

  const loadMoreProducts = () => {
    if (loading || !getHasNextPage()) return;
    loading = true;
    let requestData;

    if (isHomePage) {
      requestData = {
        action: 'load_more_new_products',
        endCursor: getEndCursor(),
      };
    } else {
      const params = new URLSearchParams(window.location.search);
      requestData = {
        action: 'load_more_products',
        search: params.get('search') ?? null,
        branding: params.get('branding') ?? null,
        colour: params.get('colour') ?? null,
        stock: params.get('stock') ?? 0,
        priceFrom: params.get('priceFrom') ?? 0,
        priceTo: params.get('priceTo') ?? 0,
        sort_by: params.get('sort_by'),
        term_id: termID ?? null,
        endCursor: getEndCursor(),
      };
    }

    // Request for more products
    $.ajax({
      type: 'GET',
      url: ajax_object.ajax_url,
      data: requestData,
      dataType: 'json',
      beforeSend: () => {
        infiniteLoader.removeClass('hidden').addClass('flex');
      },
      success: (response) => {
        if (response.success) {
          setEndCursor(response.data.endCursor);
          setHasNextPage(response.data.hasNextPage);

          $('.product-cards-wrapper').append(response.data.productsHtml);
          initFlowbite();
        }
      },
      error: (error) => {
        console.error('Error load products: ', error);
      },
      complete: () => {
        loading = false;
        infiniteLoader.removeClass('flex').addClass('hidden');
      },
    });
  };

  const savePageState = () => {
    const pageState = {
      scrollPosition: window.scrollY ?? 0,
      productHTML: $('.product-cards-wrapper').html() ?? '',
      endCursor: getEndCursor(),
      hasNextPage: getHasNextPage(),
    };
    window.history.replaceState(pageState, '');
  };

  if (isHomePage) {
    if (typeof nextPageData !== 'undefined') {
      setEndCursor(nextPageData?.endCursor);
      setHasNextPage(nextPageData?.hasNextPage);
    }
    initializeScrollObserver();
  } else {
    $(window).on('beforeunload', () => {
      sessionStorage.setItem('prevURL', currentUrl);
      savePageState();
    });

    if (infiniteLoader && typeof nextPageData !== 'undefined') {
      setEndCursor(nextPageData?.endCursor);
      setHasNextPage(nextPageData?.hasNextPage);
      termID = nextPageData?.termID;

      const prevURL = sessionStorage.getItem('prevURL') ?? '';

      if (window.history.state && currentUrl !== prevURL) {
        const historyState = window.history.state;
        setEndCursor(historyState.endCursor);
        setHasNextPage(historyState.hasNextPage);

        $('.product-cards-wrapper').empty();
        $('.product-cards-wrapper').append(historyState.productHTML);
        $('body').animate({ scrollTop: historyState.scrollPosition }, 0);

        loadMoreProducts();
      }

      initializeScrollObserver();
    }
  }
});
